import { Component, input, output } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

@Component({
  selector: 'dhp-filter-items-search-bar',
  templateUrl: './filter-items-search-bar.html',
  imports: [ReactiveFormsModule, FormsModule],
})
export class FilterItemsSearchBar {
  public readonly placeholder = input.required<string>()

  public readonly searchTermOutput = output<string>()

  public searchTerm = ''

  clearSearch(): void {
    this.searchTerm = ''

    this.searchTermOutput.emit(this.searchTerm)
  }

  onSearchChange(): void {
    this.searchTermOutput.emit(this.searchTerm)
  }
}
